import { alertDialog, filters, measures, login, } from 'i18n/en.common';
export default {
    translation: {
        panels: {
            left: {
                find: 'Find project',
                title: 'Statistics',
                general: {
                    title: 'General statistics',
                    topProjects: 'Top projects',
                    trends: 'Trends',
                },
                mostViewing: {
                    title: 'Most viewing',
                },
            },
            right: {
                title: 'Filters',
            },
        },
        content: {
            subheader: {
                filter: 'Filter',
                allTime: 'All time',
                from: 'From {{formattedDate}}',
                upTo: 'Up to {{formattedDate}}',
                interval: {
                    yearly: 'Per year',
                    quarterly: 'Per quarter',
                    monthly: 'Per month',
                    weekly: 'Per week',
                    daily: 'Per day',
                },
            },
            topProjects: {
                title: 'Top Projects',
                description: 'Top projects appearing in broker filter searches',
            },
            trends: {
                title: 'Trends',
                category: {
                    requests: 'Requests',
                    emirates: 'Emirates',
                    districts: 'Districts',
                    companies: 'Companies',
                    unit_types: 'Types',
                    layouts: 'Layouts',
                    unit_levels: 'Heights',
                },
                description: 'Broker searches with your selected filters',
                yes: 'Yes',
                no: 'No',
                unknown: 'Unknown',
                noDataChart: 'No data. Please modify filters to see statistics.',
                chartDialog: {
                    failTitle: 'Max 10 graphs',
                    failText: 'You can only add up to 10 graphs. Please remove an existing line if you\'d like to add a new one!',
                },
                customTooltip: {
                    requests_one: '{{ count }} request',
                    requests_few: '{{ count }} requests',
                    requests_many: '{{ count }} requests',
                    requests_other: '{{ count }} requests',
                },
                totalRequests: 'Total requests',
            },
            topViewersProject: {
                noDataChart: 'No data. Please modify filters to see statistics.',
                topViewers: 'Top viewers',
                contactViews: 'Contact views',
                competitorsProjects: 'Competitors projects',
            },
            topViewers: {
                title: '{{projectName}} top viewers',
                description: 'Top agencies by project views',
                backToProject: 'Back',
                noDataText: 'No data available right now. We\'re working on adding more soon!',
            },
            contactViews: {
                title: '{{projectName}} contact\'s views',
                description: 'Number of times project contacts were viewed',
                backToProject: 'Back',
                noDataChart: 'No data. Please modify filters to see statistics.',
            },
            competitors: {
                title: '{{projectName}} competitors',
                description: 'Your project among competitors in search results',
                backToProject: 'Back',
            },
            advertise: {
                start: 'Start',
                finish: 'Finish',
                days_one: '{{count}} day',
                days_few: '{{count}} days',
                days_many: '{{count}} days',
                days_other: '{{count}} days',
                notConfigured: {
                    title: 'Advertise this project',
                    description: 'Boost client visibility with larger map icons and higher project list placement.',
                    action: 'New Ad',
                },
                pending: {
                    title: 'Waiting for payment',
                    description: 'Your ad payment is pending. Please complete it to activate your ad. Unpaid ads will be automatically removed after 30 minutes.',
                    action: 'Payment',
                    cancel: 'Cancel payment',
                },
                scheduled: 'Ad starts',
                adPaymentStatus: {
                    successTitle: 'Success',
                    successText: 'Advertisements for {{projectName}} successfully launched.',
                    failTitle: 'Canceled',
                    failText: 'Please complete payment to activate your ad. Unpaid ads will be automatically removed after 30 minutes.',
                },
            },
            editAdvertiseModal: {
                title: 'Advertise ({{ name }})',
                district: 'District',
                unitType: 'Unit type',
                unitTypeSubtitle: 'Select what unit types you want to promote',
                layout: 'Layout',
                layoutSubtitle: 'Select what layouts you want to promote',
                status: 'Status',
                statusSubtitle: 'Select what statuses you want to promote',
                duration: 'Duration',
                durationSubtitle: 'Up to 30 days',
                rate: 'Rate',
                rateSubtitle: 'Price for request',
                rateHint: 'Higher price increases your priority visualization level on the map',
                select: 'Select',
                requests: 'Requests ({{ requests }}) × Rate ({{ rate }}) ÷ One week (7) × Duration ({{ duration }}) = {{ result }} AED',
                hasResale: 'Resale',
                hasOffPlan: 'Developer stock',
                save: 'Save',
                priceDescription: 'To calculate final price we use selected criteria, duration and rate.',
                proceedToCheckout: 'Proceed to check out',
                moreValidation: 'Value should be more than {{value}}',
                lessValidation: 'Value should be less than {{value}}',
            },
        },
        filterDropdown: {
            period: 'Period',
            allTime: 'All time',
            customPeriod: 'Custom period',
            from: 'From',
            to: 'To',
            interval: 'Interval',
            yearly: 'Year',
            quarterly: 'Quarter',
            monthly: 'Month',
            weekly: 'Week',
            daily: 'Day',
        },
        barChart: {
            noData: 'No data. Please modify filters to see statistics.',
        },
        login,
        common: {
            alertDialog,
            filters,
            measures,
        },
    },
};
